import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Icon } from "semantic-ui-react";

import { COMMUNICATION_CHANNELS, KEYLOCKER_COMMUNICATION_EVENT_TYPE, KEYLOCKER_PIN_REQUEST_TYPES } from "models";

import type { KeyLockerCommunication, KeyLockerCommunicationEvent } from "models";

type EventInfoProps = {
  comm: KeyLockerCommunication;
  event: KeyLockerCommunicationEvent;
};

export const EventInfo = ({ event, comm }: EventInfoProps) => {
  const { t } = useTranslation();

  const fullname = event.type === KEYLOCKER_COMMUNICATION_EVENT_TYPE.DropPINSent && comm.customer && `${comm.customer.firstname} ${comm.customer.surname}`;

  const getPinRequestType = (event: KeyLockerCommunicationEvent) => {
    const CommonText = t("v8_pin_requested_using", "Pin requested using");

    switch (event.pin_request_type) {
      case KEYLOCKER_PIN_REQUEST_TYPES.PhoneNumber:
        return <span>{`${CommonText}: ${t("v8_phone_number", "Phone number")}`}</span>;
      case KEYLOCKER_PIN_REQUEST_TYPES.RegNumber:
        return <span>{`${CommonText}: ${t("v8_reg_number", "Registration number")}`}</span>;
      case KEYLOCKER_PIN_REQUEST_TYPES.OnlineCheckIn:
        return <span>{`${CommonText}: ${t("v8_online_check_in", "Online check-in")}`}</span>;
      default:
        return null;
    }
  };

  return (
    <Grid.Row width={16} className="event-info-rows">
      {event.receivers?.map((receiver, i) => (
        <React.Fragment key={i}>
          <span>
            {receiver.communication_channel_id === COMMUNICATION_CHANNELS.Email ? <Icon name="mail" color="green" /> : <Icon name="phone" color="green" />}
            {receiver.destination}
          </span>
          {receiver.reason && (
            <span className="-margin-left-10">
              <Icon key={i} name="times circle outline" color="red" />
              {receiver.reason}
            </span>
          )}
        </React.Fragment>
      ))}

      {fullname && (
        <span>
          <Icon name="user" color="green" />
          {fullname}
        </span>
      )}

      {getPinRequestType(event)}

      {event.keylocker_name && <span>{`${t("v8_keylocker", "Keylocker")}: ${event.keylocker_name}`}</span>}
      {event.keylocker_box_number && <span>{`${t("v8_box_number", "Box number")}: ${event.keylocker_box_number}`}</span>}
    </Grid.Row>
  );
};
